import { Button, styled } from '@mui/material'
import { memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateModal } from '../../../store/app/actions/modalActions'
import { useWeb3Connected } from '../../../store/web3/hooks'

export const ConnectButtonWrap = styled(Button)`
  flex-shrink: 0;
  height: 36px;
  gap: 4px;
  padding: 0 12px;
  color: ${({ theme }) => theme.color.text00};
  white-space: nowrap;
  background: ${({ theme }) => theme.color.primary30};
  border-radius: 18px;

  &:hover {
    background: rgba(199, 255, 92, 1);
  }
`

export const ConnectButton = memo(() => {
  const dispatch = useDispatch()
  const web3Connected = useWeb3Connected()

  const handleClick = () => {
    if (!web3Connected) {
      dispatch(updateModal({ modal: 'wallets', open: true }))
    }
  }

  return (
    <ConnectButtonWrap onClick={handleClick}>Connect Wallet</ConnectButtonWrap>
  )
})
